export var ImageSize;
(function (ImageSize) {
    ImageSize["Small"] = "Small";
    ImageSize["Medium"] = "Medium";
    ImageSize["Large"] = "Large";
})(ImageSize || (ImageSize = {}));
